document.addEventListener("DOMContentLoaded", () => {

  const bar = document.getElementById("rusticCategoryBar");
  if (!bar) return;

  const groups = document.querySelectorAll(".rustic-category-group");

  function hideBar() {
    bar.classList.remove("show");
    groups.forEach(group => group.classList.remove("active"));
  }

  function showGroup(name) {

    groups.forEach(group => group.classList.remove("active"));

    const target = document.querySelector(`[data-group="${name}"]`);

    if (target) {
      target.classList.add("active");
      bar.classList.add("show");
    }

    // =============================
    // ACTIVAR MENÚ PRINCIPAL
    // =============================

    document.querySelectorAll(".menu-list__link").forEach(link => {
    link.classList.remove("menu-list__link--active");
    });

    const activeLink = [...document.querySelectorAll(".menu-list__link")].find(link =>
      link.textContent.trim().toLowerCase() === name
    );

    if (activeLink) {
    activeLink.classList.add("menu-list__link--active");
    }

  }

  // -------------------------
  // Detectar página actual
  // -------------------------

  const path = window.location.pathname.toLowerCase();

  if (path.includes("/collections/hombre")) {

    showGroup("hombre");

  } else if (

    path.includes("/collections/camisetas") ||
    path.includes("/collections/bordadas") ||
    path.includes("/collections/estampadas") ||
    path.includes("/collections/camiseta-edicion-limitada-1") ||
    path.includes("/collections/polos") ||
    path.includes("/collections/jeans-1") ||
    path.includes("/collections/bermudas") ||
    path.includes("/collections/pantalonetas") ||
    path.includes("/collections/camisas") ||
    path.includes("/collections/chaquetas") ||
    path.includes("/collections/conjuntos")

  ) {

    showGroup("hombre");

  } else if (

    path.includes("/collections/mujer") ||
    path.includes("/collections/jeans") ||
    path.includes("/collections/polos-mujer")

  ) {

    showGroup("mujer");
    
     } else if (

    path.includes("/collections/accesorios") ||
    path.includes("/collections/zapatos")

  ) {

    showGroup("accesorios");


  } else if (

    path.includes("/drops") ||
    path.includes("creative") ||
    path.includes("first-step") ||
    path.includes("cali-490")

  ) {

    showGroup("drops");

  } else {

    hideBar();

  }

});